import { render } from "./ServiciosPrestadosListado.vue?vue&type=template&id=1b8f8db4&ts=true"
import script from "./ServiciosPrestadosListado.vue?vue&type=script&lang=ts"
export * from "./ServiciosPrestadosListado.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__